import React, {useEffect, useState } from 'react'
import { useSelector } from 'react-redux';

const PopularDetails = () => {
  const [data, setData] = useState([])
  const post = useSelector((state) => state.popular)

  console.log(post)

  // useEffect(() => {
    
  //   }, [])

  return (
    <div>PopularDetails are</div>
  )
}

export default PopularDetails